import {
	FormatNumber,
	HStack,
	Stack,
	Text,
} from '@chakra-ui/react';

import { useTranslations } from 'next-intl';

type CartSummaryDetailProps = {
	itemCount:         number;
	beforeDiscount:    number;
	shippingFee:       number;
	memberDiscount:    number;
	promotionDiscount: number;
	finalPrice:        number;
};

const CartSummaryDetail = ({
	itemCount,
	beforeDiscount,
	shippingFee,
	memberDiscount,
	promotionDiscount,
	finalPrice,
}: CartSummaryDetailProps) => {
	const t = useTranslations('CartPage.cartSummary');

	return (
		<Stack gap={8}>
			<Stack gap={1}>
				<HStack justifyContent={'space-between'} textStyle={'p3'}>
					<Text>{t('subtotal', { quantity: itemCount })}</Text>
					<FormatNumber
						currency={'THB'}
						currencyDisplay={'narrowSymbol'}
						style={'currency'}
						value={beforeDiscount}
					/>
				</HStack>
				{shippingFee > 0 && (
					<HStack alignItems={'center'} justifyContent={'space-between'}>
						<Text>{t('shipping')}</Text>
						<FormatNumber
							currency={'THB'}
							currencyDisplay={'narrowSymbol'}
							style={'currency'}
							value={shippingFee}
						/>
					</HStack>
				)}
				{memberDiscount > 0
					&& (
						<HStack color={'red'} justifyContent={'space-between'} textStyle={'p3'}>
							<Text>{t('memberDiscount')}</Text>
							<FormatNumber
								currency={'THB'}
								currencyDisplay={'narrowSymbol'}
								currencySign={'accounting'}
								style={'currency'}
								value={memberDiscount * -1}
							/>
						</HStack>
					)}
				<HStack color={'red'} justifyContent={'space-between'} textStyle={'p3'}>
					<Text>{t('discount')}</Text>
					<FormatNumber
						currency={'THB'}
						currencyDisplay={'narrowSymbol'}
						currencySign={'accounting'}
						style={'currency'}
						value={promotionDiscount * -1}
					/>
				</HStack>
			</Stack>
			<HStack justifyContent={'space-between'} textStyle={'s6'}>
				<Text>{t('total')}</Text>
				<FormatNumber
					currency={'THB'}
					currencyDisplay={'narrowSymbol'}
					style={'currency'}
					value={finalPrice}
				/>
			</HStack>
		</Stack>
	);
};

export default CartSummaryDetail;
